import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import "../styles/NotUserFriend.css";
import profileImg from '../images/profile.jpg';
import { toLowQualityPic } from '../images/toLowQualityPic';
import {UserPlus} from "lucide-react"
import ImageWithLoader from './ImageWithLoader';

export const NotUserFriend = (props) => {
    const { loading, handleAddFriend, notUserFriendsData, setLoading, fetchNonFriendsData } = props;
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                await fetchNonFriendsData();
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [fetchNonFriendsData, setLoading]);

    if (error) {
        return <div className='error'>{error}</div>;
    }

    return (
        <div className='NotUserFriend'>
            <h4 style={{ marginBottom: "10px" }}>ADD FRIENDS</h4>
            <div className='NUF_data'>
                {notUserFriendsData.map((notUserFriend, index) => (
                    <div className="NotUserFriend__container" key={notUserFriend._id}>
                        <div className='NotUserFriend__userDetails'>
                            <ImageWithLoader className='NUF_profilePic' src={notUserFriend.profilePic ? toLowQualityPic(notUserFriend.profilePic) : profileImg} alt={notUserFriend.username} />
                            <div>
                                <h3 className='NotUserFriend__username'>{notUserFriend.username}</h3>
                                <p><span className='NotUserFriend__rating'>&#8902; </span>{notUserFriend.rating}</p>
                            </div>
                        </div>

                        <button
                            className='inviteFriendBtn quickMatchBtn NotUserFriendQuickMatchBtn'
                            disabled={!notUserFriend.status}
                            onClick={() => handleAddFriend(notUserFriend._id)}
                        >
                            <UserPlus size={"1.3rem"}/>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

// Add PropTypes for type checking
NotUserFriend.propTypes = {
    loading: PropTypes.bool.isRequired,
    handleAddFriend: PropTypes.func.isRequired,
    notUserFriendsData: PropTypes.array.isRequired,
    setLoading: PropTypes.func.isRequired,
    fetchNonFriendsData: PropTypes.func.isRequired,
};

export default NotUserFriend;
